import React, { useEffect, useState } from 'react';
import { CheckCircle2, Image as ImageIcon, Keyboard, X, Zap, ZapOff } from 'lucide-react';
import { images } from '../../../data/images';
import type { MobileNav } from '../../../types/mobile';
export function ScannerScreen({
  nav
}: {
  nav: MobileNav;
}) {
  const [flash, setFlash] = useState(false);
  const [detected, setDetected] = useState(false);
  const qr = nav.scenario === 'valid' ? 'CNG-000001' : 'CNG-000004';
  useEffect(() => {
    const t1 = window.setTimeout(() => setDetected(true), 2200);
    return () => window.clearTimeout(t1);
  }, [nav.scenario]);
  const {
    back,
    go,
    scenario
  } = nav;
  useEffect(() => {
    if (!detected) return;
    const t2 = window.setTimeout(() => {
      back();
      go(scenario === 'valid' ? 'result' : 'invalid');
    }, 900);
    return () => window.clearTimeout(t2);
  }, [detected, back, go, scenario]);
  return <div className="relative flex h-full flex-col overflow-hidden bg-black text-white" data-id="element-562" data-mp="13vt9a6mb7lmh">
      <img src={images.cng} alt="" aria-hidden className={`absolute inset-0 h-full w-full scale-125 object-cover ${flash ? 'brightness-90' : 'brightness-50'}`} data-id="element-563" data-mp="wvor5lshys8w" />
      <div className="relative z-10 flex items-center justify-between px-4 pt-3" data-id="element-564" data-mp="ryyfrbrn0ktt">
        <button onClick={nav.back} aria-label="বন্ধ করুন" className="flex h-9 w-9 items-center justify-center rounded-full bg-black/40" data-id="element-565" data-mp="myaocozhy1z2"><X className="h-5 w-5" data-id="element-566" data-mp="iyjqy2fgsnlk" /></button>
        <div className="flex rounded-full bg-black/50 p-0.5 text-[11px]" role="group" aria-label="ডেমো স্ক্যান ফলাফল" data-id="element-567" data-mp="1fmproe99mvuk">
          <button onClick={() => {
          setDetected(false);
          nav.setScenario('valid');
        }} className={`rounded-full px-2.5 py-1 ${nav.scenario === 'valid' ? 'bg-bdgreen-600' : ''}`} data-id="element-568" data-mp="1aoo7fq03sqhi">ডেমো: বৈধ</button>
          <button onClick={() => {
          setDetected(false);
          nav.setScenario('invalid');
        }} className={`rounded-full px-2.5 py-1 ${nav.scenario === 'invalid' ? 'bg-red-600' : ''}`} data-id="element-569" data-mp="11u9v9wavdw2m">ডেমো: অবৈধ</button>
        </div>
      </div>

      <div className="relative z-10 flex flex-1 flex-col items-center justify-center px-8" data-id="element-570" data-mp="1tkxuv3wwate6">
        <p className="mb-5 text-center text-sm font-medium leading-relaxed" data-id="element-571" data-mp="3nul4pksgd3kb">“সিএনজি গাড়িতে থাকা ডিএমপি কিউআর স্টিকারটি স্ক্যান করুন”</p>
        <button onClick={() => setDetected(true)} className="relative h-60 w-60" aria-label="স্ক্যান সিমুলেট করুন" data-id="element-572" data-mp="3e49qn5f21dzp">
          {['left-0 top-0 border-l-4 border-t-4 rounded-tl-xl', 'right-0 top-0 border-r-4 border-t-4 rounded-tr-xl', 'left-0 bottom-0 border-l-4 border-b-4 rounded-bl-xl', 'right-0 bottom-0 border-r-4 border-b-4 rounded-br-xl'].map(c => <span key={c} className={`absolute h-10 w-10 ${detected ? 'border-emerald-400' : 'border-white'} ${c}`} data-id="element-573" data-mp="3a49angcb4uqj" />)}
          {!detected && <span className="scan-line absolute left-3 right-3 h-0.5 bg-emerald-400 shadow-[0_0_12px_2px_rgba(52,211,153,0.7)]" data-id="element-574" data-mp="304id15sg9zm8" />}
          {detected && <span className="absolute inset-0 flex flex-col items-center justify-center rounded-xl bg-emerald-500/20" data-id="element-575" data-mp="tekb0q6j1o5y">
              <CheckCircle2 className="h-14 w-14 text-emerald-400" data-id="element-576" data-mp="yb18wc3j3gw8" />
              <span className="mt-2 rounded bg-black/60 px-2 py-1 font-mono text-sm" data-id="element-577" data-mp="2ivy1yazdzyjb">{qr}</span>
            </span>}
        </button>
        <p className="mt-5 text-xs text-white/80" data-id="element-578" data-mp="2du8q4t4cbgu6">{detected ? 'QR শনাক্ত হয়েছে — তথ্য আনা হচ্ছে…' : 'স্টিকারটি ফ্রেমের ভেতরে রাখুন'}</p>
      </div>

      <div className="relative z-10 grid grid-cols-3 gap-2 bg-black/60 px-6 pb-7 pt-4" data-id="element-579" data-mp="2nt7w23xq0ydh">
        <ScanCtl label="ফ্ল্যাশ" onClick={() => setFlash(!flash)} active={flash} data-id="element-580" data-mp="31kw703w8hgsv">{flash ? <Zap className="h-5 w-5" data-id="element-581" data-mp="2xklsu3yafk2x" /> : <ZapOff className="h-5 w-5" data-id="element-582" data-mp="2xjaoo30xkaba" />}</ScanCtl>
        <ScanCtl label="গ্যালারি" onClick={() => setDetected(true)} data-id="element-583" data-mp="3bjtud3hxb4aa"><ImageIcon className="h-5 w-5" data-id="element-584" data-mp="3bjbp5hda9fq8" /></ScanCtl>
        <ScanCtl label="ম্যানুয়াল সার্চ" onClick={() => {
        nav.back();
        nav.go('search');
      }} data-id="element-585" data-mp="36l0g38utb992"><Keyboard className="h-5 w-5" data-id="element-586" data-mp="36ixtyzws609m" /></ScanCtl>
      </div>
    </div>;
}
function ScanCtl({
  label,
  onClick,
  children,
  active
}: {
  label: string;
  onClick: () => void;
  children: React.ReactNode;
  active?: boolean;
}) {
  return <button onClick={onClick} className="flex flex-col items-center gap-1.5 text-xs" data-id="element-587" data-mp="1doeqk2r3hc35">
      <span className={`flex h-12 w-12 items-center justify-center rounded-full ${active ? 'bg-amber-400 text-black' : 'bg-white/15'}`} data-id="element-588" data-mp="1impy26tx3ai7">{children}</span>
      {label}
    </button>;
}